(async function () {
  if (
    "serviceWorker" in navigator &&
    navigator.serviceWorker instanceof ServiceWorkerContainer
  ) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    registrations.forEach((registration) => registration.unregister());
  }
})();
